<template>
    <div class="bg-white w-100 full-height">

        <!-- Navbar -->
        <b-alert show variant="primary" class="d-flex justify-content-between align-items-center shadow-sm rounded p-4">
            <img src="/img/brand/logo-soluquim-color.webp" width="100" alt="Soluquim">
            <div>
                <a href="https://app.soluquim.co" target="_blank" class="text-primary font-weight-bold">
                    <i class="fa fa-eye text-primary cursor-pointer"></i>
                    Visitar Soluquim
                </a>
            </div>
        </b-alert>

        <!-- Producto valido -->
        <div v-if="isValidProduct" class="container mt-4">
            <b-row>

                <b-col sm="12" md="8">
                    <div class="border-left shadow-sm rounded  px-4 pt-4 pb-2 bg-white mb-2">
                        <div class="content-general-sm mb-2 d-flex justify-content-between flex-wrap">
                            <strong>Nombre Producto</strong>
                            <span>{{ productVisualized.nombre || 'N/A' }}</span>
                        </div>

                        <div class="content-general-sm mb-2 d-flex justify-content-between flex-wrap">
                            <strong>Estado</strong>
                            <span>{{ productVisualized.state_type ? productVisualized.state_type.lista : 'N/A' || 'N/A' }}</span>
                        </div>

                        <div class="content-general-sm mb-2 d-flex justify-content-between flex-wrap">
                            <strong>Uso</strong>
                            <span>{{ productVisualized.uso || 'N/A' }}</span>
                        </div>
                    </div>

                    <div class="border-left shadow-sm rounded px-4 py-4 bg-white mb-2">
                        <div class="mb-3">
                            <strong>Componentes</strong>
                            <span class="d-block mt-2">{{ productVisualized.formatComponents || 'N/A' }}</span>
                        </div>
                        <div class="mb-3">
                            <strong>Sinonimos</strong>
                            <span class="d-block mt-2">{{ productVisualized.sinonimos || 'N/A' }}</span>
                        </div>
                        <div class="mb-3">
                            <strong>Fabricante</strong>
                            <span class="d-block mt-2">{{ productVisualized.manufacturer ? productVisualized.manufacturer.nombre : 'N/A' || 'N/A' }}</span>
                        </div>
                        <div>
                            <strong>Número de emergencias</strong>
                            <span class="d-block mt-2">{{ productVisualized.personalizedMessage || 'N/A' }}</span>
                        </div>
                    </div>

                    <div class="border-left shadow-sm rounded px-4 pt-4 pb-1 bg-white">
                        <strong>Indicaciones de peligro (Frases H)</strong>
                        <div v-html="productVisualized.indicationsHazard  || '<span>N/A</span>'" class="d-block mt-3"></div>
                    </div>

                </b-col>

                <b-col sm="12" md="4">

                    <!-- Adjuntos -->
                    <div class="shadow-sm rounded-lg bg-white">

                        <h4 class="d-flex justify-content-between align-items-center mb-3 px-4 pt-1 mt-2">
                            <strong>Adjuntos</strong>
                            <b-badge variant="primary">{{ attachments.length }}</b-badge>
                        </h4>

                        <ul class="m-0 p-3 pb-4" v-if="attachments.length > 0">
                            <div v-for="attachment in attachments" :key="attachment.id"
                                class="mb-2 d-flex justify-content-start align-items-center rounded shadow-sm bg-gray-100 p-2">

                                <div class="d-flex justify-content-center align-items-center">
                                    <b-spinner
                                        v-if="loadingDownloadAttachment.status && loadingDownloadAttachment.id == attachment.id"
                                        variant="primary" label="Spinning"></b-spinner>
                                    <i v-else @click="onHandleDownloadFileAttachment(attachment.id)"
                                        class="fa fa-cloud-download fa-2x text-primary cursor-pointer"></i>
                                </div>

                                <div class="ml-2 w-100">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <strong class="m-0 p-0">{{ attachment.tipo_adjunto ? attachment.tipo_adjunto.lista : 'N/A' }}</strong>
                                        <b-badge variant="info"><small class="text-white">{{ attachment.language ? attachment.language.name : 'N/A' }}</small></b-badge>
                                    </div>
                                    <small class="text-muted d-block"><strong>Fecha:</strong> {{ attachment.fecha || 'N/A' }}</small>
                                    <small class="text-muted d-block"><strong>Fecha de revisión:</strong> {{
                                        attachment.fechavencimiento || 'N/A' }}</small>
                                </div>
                            </div>
                        </ul>
                        <div v-else class="px-4 pb-2">
                            <b-alert show variant="warning">
                                <i class="fa fa-info-circle mr-1"></i>
                                No hay adjuntos disponibles
                            </b-alert>
                        </div>
                    </div>

                    <!-- Pictogramas -->
                    <div class="shadow-sm rounded-lg px-4 pb-2 bg-white mt-4">

                        <h4 class="d-flex justify-content-between align-items-center mb-3">
                            <strong>Pictogramas</strong>
                            <b-badge variant="danger">{{ pictograms.length }}</b-badge>
                        </h4>

                        <b-row v-if="pictograms.length > 0">
                            <b-col class="px-3" cols="2" v-for="pictogram in pictograms" :key="pictogram.id">
                                <b-img :src="pictogram.path" width="45" alt="placeholder"></b-img>
                            </b-col>
                        </b-row>
                        <div v-else>
                            <b-alert show variant="warning">
                                <i class="fa fa-info-circle mr-1"></i>
                                Sin pictogramas
                            </b-alert>
                        </div>
                    </div>

                </b-col>

            </b-row>
        </div>

        <!-- Cargando datos -->
        <div class="text-center p-4 container" v-if="loading">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>

        <br />
        <br />

    </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions } from 'vuex';

export default {
    name: 'qrcode',
    computed: {
        // Estados del modulo del visualizador
        ...mapState('visualizer', [
            'productVisualized',
            'loading',
            'loadingDownloadAttachment'
        ]),
        /**
         * Cargar los pictogramas.
         * @author Fernando Claros
         */
        pictograms() {
            if (!this.productVisualized || !('pictograms' in this.productVisualized) || typeof this.productVisualized.pictograms !== 'object')
                return [];

            return this.productVisualized.pictograms;
        },
        /**
         * Cargar los adjuntos.
         * @author Fernando Claros
         */
        attachments() {
            if (!this.productVisualized || !('attachments' in this.productVisualized) || typeof this.productVisualized.attachments !== 'object')
                return [];

            return this.productVisualized.attachments;
        },
        /**
         * Verificar si el producto cargado es valido.
         * @author Fernando Claros
         */
        isValidProduct() {
            if (!this.productVisualized || typeof this.productVisualized !== 'object')
                return false;

            return true;
        }
    },
    async mounted() {
        const { hashKey } = this.$route.params;

        // Cargar los detalles del producto mediante la url del qr.
        await this.getDetailsUsingTheQrUrl(hashKey);
    },
    methods: {
        // Metodos del modulo del visualizador
        ...mapActions('visualizer', [
            'getDetailsUsingTheQrUrl',
            'downloadAttachmentFile'
        ]),
        /**
         * Descargar el archivo del adjunto.
         * @author Fernando Claros
         */
        async onHandleDownloadFileAttachment(id) {
            await this.downloadAttachmentFile({
                id,
                nameProduct: this.productVisualized.nombre
            });
        },
    },
};
</script>

<style scoped>
html,
body {
    font-size: 13px;
}

.full-height {
    height: 100vh;
    overflow-y: auto;
}

.max-height-attactments {
    max-height: 350px;
    overflow-y: auto;
}

.border-left {
    border-left: 4px solid #D2EEF7 !important;
}

@media (min-width: 0px) and (max-width: 890px) {

    .content-general-sm,
    .content-general-sm strong {
        display: block !important;
    }

    .content-general-sm span {
        display: block !important;
        margin-top: 4px;
    }
}</style>

